class Ajaxinate extends HTMLElement {
  constructor(options = {}) {
    super();
    const defaults = {
      pagination: "[js-btn-load-more]",
      method: "click",              // "click" or "scroll"
      container: "#collectionGrid",
      offset: 0,
      loadingText: `<div class="loader"><div class="loader__wrap">
                <div class="loader__bar"></div>
            </div>
        </div>`,
      callback: null
    };

    this.settings = Object.assign({}, defaults, options);

    // Bind methods so "this" stays correct in listeners
    this.addScrollListeners = this.addScrollListeners.bind(this);
    this.addClickListener = this.addClickListener.bind(this);
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
    this.destroy = this.destroy.bind(this);
    this.loadMore = this.loadMore.bind(this);

    this.containerElement = document.querySelector(this.settings.container);
    this.paginationElement = document.querySelector(this.settings.pagination);

    this.initialize();
  }

  initialize() {
    if (!this.containerElement) return;

    const methods = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };

    if (methods[this.settings.method]) {
      methods[this.settings.method]();
    }
  }

  addScrollListeners() {
    if (!this.paginationElement) return;

    document.addEventListener("click", this.checkIfPaginationInView);
    window.addEventListener("resize", this.checkIfPaginationInView);
    window.addEventListener("orientationchange", this.checkIfPaginationInView);

    // Run once on init to load if already in view
    this.checkIfPaginationInView();
  }

  addClickListener() {
    if (!this.paginationElement) return;

    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.clickActive = true;

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
    }
  }

  stopMultipleClicks(e) {
    e.preventDefault();
    if (!this.clickActive) return;

    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;

    this.loadMore();
  }

  checkIfPaginationInView() {
    if (!this.paginationElement) return;

    const rect = this.paginationElement.getBoundingClientRect();
    const top = rect.top - this.settings.offset;
    const bottom = rect.bottom + this.settings.offset;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");

      this.removeScrollListener();

      if (this.nextPageLinkElement) {
        this.nextPageLinkElement.innerHTML = this.settings.loadingText;
        this.nextPageUrl = this.nextPageLinkElement.href;
        this.loadMore();
      }
    }
  }

  loadMore() {
    this.request = new XMLHttpRequest();

    this.request.onreadystatechange = () => {
      if (this.request.readyState === 4 && this.request.status === 200) {
        const doc = this.request.responseXML;

        const newContainer = doc.querySelectorAll(this.settings.container)[0];
        const newPagination = doc.querySelectorAll(this.settings.pagination)[0];

        if (newContainer) {
          this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);
        }

        if (newPagination) {
          this.paginationElement.innerHTML = newPagination.innerHTML;
        } else {
          // No more pages → remove pagination area
          this.paginationElement.innerHTML = "";
        }

        if (this.settings.callback && typeof this.settings.callback === "function") {
          this.settings.callback(doc);
        }

        // Re-init to attach listeners to new pagination link
        this.initialize();
      }

      // Keep your custom events
      document.dispatchEvent(new CustomEvent("get-all-images-initialized:lazy"));
      document.dispatchEvent(new CustomEvent("media-slider:init"));
    };

    this.request.open("GET", this.nextPageUrl);
    this.request.responseType = "document";
    this.request.send();
  }

  removeClickListener() {
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
    }
  }

  removeScrollListener() {
    document.removeEventListener("click", this.checkIfPaginationInView);
    window.removeEventListener("resize", this.checkIfPaginationInView);
    window.removeEventListener("orientationchange", this.checkIfPaginationInView);
  }

  destroy() {
    const removers = {
      click: this.removeClickListener.bind(this),
      scroll: this.removeScrollListener.bind(this)
    };

    if (removers[this.settings.method]) {
      removers[this.settings.method]();
    }

    return this;
  }
}

customElements.define('load-more-collection', Ajaxinate)